import styled, { css } from 'styled-components';

export const Description = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km6};
  `}
`;

export const BenefitsContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km4};
  `}
`;

export const BenefitsIconContainer = styled.div`
  ${({ theme: { spacing, border, color } }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${spacing.km10};
    height: ${spacing.km10};
    border-radius: ${border.radius.circle};
    background: ${color.background.neutral.weak};
  `}
`;

export const BenefitsTitleContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km2};
  `}
`;

export const BenefitItem = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-gap: ${spacing.km4};
    grid-template-columns: 0.75rem auto;
    align-items: center;
  `}
`;
